module.exports = __webpack_public_path__ + "static/white_bg1-aa12a6f66fb627646bbf3a0d9a7319be.svg";